import React from "react";
import Widget from "components/Widget";
import SupplementList from "components/Table/List";
import ActionMenu from "components/Table/Actions/ActionDropdown";
import Layout from "components/Layout";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditSupplement from "./components/EditSupplement";
import AddNewSupplement from "./components/AddSuplement";
import SearchBox from "components/Filters/SearchBox";
import UploadCSV from "components/uploadCSV";
import ShowModal from "components/Modal/ShowModal";
import { Tag } from "antd";
const Supplement = () => {
  const columns = [
    {
      title: " Name",
      render: (record) => <span>{record.supplementName}</span>,
      key: "Name",
    },
    {
      title: " ",
      render: (record) => <ActionMenu menu={renderActions(record)} />,
      key: "action",
      width: "50px",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column gx-pointer ">
        <ShowModal
          record={record}
          modalName={"Edit_Supplement_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteSupplement"
          recordName="supplementList"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this Supplement?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>SUPPLEMENTS</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281664571-supplementName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getSupplements"
              recordName="supplementList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />

            <UploadCSV
              type="getSupplements"
              url="bulkImportSkills"
              table="Supplement"
              recordName="supplementList"
              cb="supplementName"
              uId="supplementId"
            />
            <AddNewSupplement />
          </div>
        }
      >
        <SupplementList
          recordName="supplementList"
          apiName="getSupplements"
          columns={columns}
        />
      </Widget>

      {<EditSupplement />}
    </Layout>
  );
};

export default Supplement;
